import { render } from "./ContactList.vue?vue&type=template&id=3af6dd08&ts=true"
import script from "./ContactList.vue?vue&type=script&lang=ts"
export * from "./ContactList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__